module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAABDUlEQVRoQ+3ZSw7CMAxFUb+dwU7oyig7YWdBHURiEBXFn2cHyLzSPXErNQpk8YXF++UPyJ5gygRaaxcATw88HdBau4nIXUR2AJsVQQW8xfduM4IGGMR3xNXyOlEAJ/EbgN3yGoUDIuMPeCggOj4UwIgPA7DiQwDMeHcAO94VkBHvBsiKdwFkxpsB2fEmQIV4NaBKvApQKX4aUC1+ClAx/rcAh7biFKbPA9UQ04Bqk1ABKiHUgCoIE6ACwgzIRrgAMhFugCyEKyAD4Q5gI0IATEQYgIUIBTAQ4YBoBAXwAVH/gqNfYAx+xR8Ajjsz9aJNYIAwx08dKdVbNHhw6WtWz41Im4Angv4NeMZ/xQReQJ3GMe66PmUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/back.png
// module id = 261
// module chunks = 0